import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {AccountManagementMenu} from '../Enums/Enums';

class MenuAccountManagement extends React.Component {
  state = {
    value: 1,
  };

  handleChange = (event, value) => {
    this.setState({ value });
    this.props.data.APX.AccountManagementCallback(value);
  };

  render() {
    const { value } = this.state;
    return (
        <div>
            <Tabs value={value} onChange={this.handleChange.bind(this)}>
              <Tab label="RE-TIER"   value={AccountManagementMenu.ReTier} />
              <Tab label="DOCUMENT REQUEST"  value={AccountManagementMenu.DocumentRequest} />
              <Tab label="MANAGE"  value={AccountManagementMenu.Manage} />}
            </Tabs>
        </div>
    );
  }
}

export default MenuAccountManagement;